<template>
  <form-radio
    :id="id"
    :name="name"
    :label="label"
    :disabled="isDisabled"
    :is-update-in-process="planetStore.isUpdateInProcess"
    :ignore-update-in-process="ignoreUpdateInProcess"
    :classes="classes"
    :checked="checked"
    :data-qa="dataQa"
    @input="emit('input', $event)"
  >
  </form-radio>
</template>

<script setup lang="ts">
import FormRadio from 'ui-component-library/rbz/components/FormRadio.vue';
import { usePlanetStore } from '@/store/PlanetStore';
import { computed } from 'vue';

const planetStore = usePlanetStore();
interface RbzFormRadioProps {
  id: string;
  label?: string;
  disabled?: boolean;
  checked?: boolean;
  isUpdateInProcess?: boolean;
  ignoreUpdateInProcess?: boolean;
  name?: string;
  classes?: string;
  dataQa?: string;
}

// This `props` is being used by spec files

const props = withDefaults(defineProps<RbzFormRadioProps>(), {
  label: '',
  disabled: false,
  name: 'radio',
  classes: '',
  dataQa: '',
});

const isDisabled = computed(() => {
  return props.disabled || (planetStore.isUpdateInProcess && !props.ignoreUpdateInProcess);
});

interface FormRadioEmits {
  (e: 'input'): void;
}

const emit = defineEmits<FormRadioEmits>();
</script>
